<template>
  <b-modal
      ref="modal-window"
      :title="$t('table-field.table-column-chooser.title')"
      size="lg modal-fullscreen-xxl-down"
  >
    <template #modal-body>
      <label class="help-block before-field">{{ $t('table-field.table-column-chooser.description') }}</label>
      <div
          v-for="col in columns"
          :key="col.key"
          class="d-flex align-items-center gap-2 w-100 cursor-pointer hover-text-black"
      >
        <CheckboxField
            :modelValue="!isColumnHidden(col.key)"
            :disabled="isLastVisibleColumn(col.key)"
            @update:modelValue="val => handleToggleColumn(col.key, val)"
            :label="col.key === 'actions' ? 'Actions' : col.title"
        />
      </div>

      <h6 class="pt-3">{{ $t('table-field.table-column-chooser.records-title') }}</h6>
      <label class="help-block before-field">{{ $t('table-field.table-column-chooser.records-description') }}</label>
      <AdvancedSelect
          v-model="localPageSize"
          :items="[
            { text: 10, value: 10 },
            { text: 20, value: 20 },
            { text: 30, value: 30 },
            { text: 50, value: 50 },
            { text: 100, value: 100 },
          ]"
          :hideClearIcon="true"
      />
    </template>

    <template #modal-footer>
      <span class="btn btn-secondary" @click="close()">{{ $t('client.cancel') }}</span>
      <span class="btn btn-primary" @click="submit()">{{ $t('client.create') }}</span>
    </template>
  </b-modal>
</template>

<script>
import CheckboxField from "@/components/common/checkbox-field/CheckboxField.vue";
import AdvancedSelect from "@/components/common/advanced-select/AdvancedSelect.vue";
export default {
  name: 'TableColumnChooser',
  emits: ['changeColumns', 'update:pageSize'],

  components: {
    CheckboxField,
    AdvancedSelect
  },

  props: {
    pageSize: { type: Number, required: true },
    section: { type: [String, null], default: null }
  },

  data: () => ({
    isOpen: false,
    loading: false,
    columns: [],
    columnVisibility: {},
    localPageSize: null
  }),

  methods: {
    async show (columns, section) {
      this.columns = this.BasicHelper.cloneObject(columns);
      const savedColumns = localStorage.getItem(`${section}-columns`);
      this.columnVisibility = savedColumns ? JSON.parse(savedColumns) : {};
      this.$refs['modal-window'].show();
    },

    async submit() {
      this.loading = true;
      try {
        if (Object.keys(this.columnVisibility).length === 0) {
          localStorage.removeItem(`${this.section}-columns`);
        } else {
          localStorage.setItem(`${this.section}-columns`, JSON.stringify(this.columnVisibility));
        }
        localStorage.setItem(`${this.section}-page-size`, this.localPageSize);

        const updatedColumns = this.columns.map(col => ({
          ...col,
          hide: this.columnVisibility[col.key] ?? false
        }));

        this.$emit('changeColumns', updatedColumns);
        this.$emit('update:pageSize', this.localPageSize);

        await this.ApiRequest.requestAsync(
            `user/filter/columns/store`,
            this.ApiRequest.REQUEST_POST,
            { columnVisibility: this.columnVisibility, section: this.section, pageSize: this.localPageSize },
            'store-columns',
            true
        );

        this.$refs['modal-window'].hide();
      } finally {
        this.loading = false;
      }
    },

    isColumnHidden(key) {
      return !!this.columnVisibility[key];
    },

    isLastVisibleColumn(key) {
      const visibleColumns = this.columns.filter(
          col => !this.isColumnHidden(col.key) && col.key !== key
      );
      return visibleColumns.length === 0 && !this.isColumnHidden(key);
    },

    handleToggleColumn(key, checked) {
      if (!checked && this.isLastVisibleColumn(key)) {
        return;
      }

      if (!checked) {
        this.columnVisibility[key] = true;
      } else {
        delete this.columnVisibility[key];
      }
    },

    close () {
      this.$refs['modal-window'].hide();
    }
  },

  mounted() {
    this.localPageSize = this.pageSize;
  },

  watch: {
    pageSize(val) {
      this.localPageSize = val;
    }
  }
}
</script>

<style scoped>
  .help-block.before-field {
    margin-top: 0;
    margin-bottom: 17px;
    display: block;
    color: #777;
  }
  .help-block {
    font-size: 13px;
    margin-bottom: 0;
  }
</style>
